import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getIsDarkTheme } from '../../reducers';
import tradingViewIcon from '../../resources/brand/trading-view-icon-logo.png';
import tradingViewIconDark from '../../resources/brand/trading-view-icon-logo-dark.png';
import customScriptIcon from '../../resources/brand/custom-scripts-icon-logo.png';
import customScriptIconDark from '../../resources/brand/custom-scripts-icon-logo-dark.png';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    '&:empty': {
      display: 'none',
    },

    '& img': {
      display: 'inline-flex',
      width: 24,
      height: 'auto',
      marginRight: 8,
    },
  },
}));

const SourceImage = ({ value }) => {
  const classes = useStyles();
  const isDarkTheme = useSelector(getIsDarkTheme);
  const tradingViewIconSrc = isDarkTheme
    ? tradingViewIconDark
    : tradingViewIcon;

  const customScriptIconSrc = isDarkTheme
    ? customScriptIconDark
    : customScriptIcon;

  return (
    <span className={classes.root}>
      {value === 'tv' ? <img src={tradingViewIconSrc} alt="tv" /> : ''}
      {value === 'custom' ? <img src={customScriptIconSrc} alt="custom" /> : ''}
    </span>
  );
};

export default SourceImage;
